import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    getBusinessAddressDetails
} from 'services/redux/brandActivtion/conductCamp/action';
import AddressBusinessListing from './businessAddressListing';
import {
  locationArea
} from "services/redux/sales/corporate/locations/action";
import { findAllInRenderedTree } from 'react-dom/test-utils';

const mapStateToProps = (state) => ({
    businessAddressListing: state.ConductCampReducer.businessAddressDetails
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        getBusinessAddressDetails
    },
    dispatch
  );


export default connect(mapStateToProps, mapDispatchToProps)(AddressBusinessListing);
